import * as React from "react";

import {USER_THEME_KEY} from "../constants";

const useThemeHandler = (initialState: string) => {
  const [theme, setTheme] = React.useState(initialState);

  const setThemeStatus = (theme: string) => {
    if (theme === "") {
      window.localStorage.removeItem(USER_THEME_KEY);
    } else {
      window.localStorage.setItem(USER_THEME_KEY, theme);
    }

    setTheme(theme);
  };

  return {
    theme,
    setThemeStatus
  };
};

export default useThemeHandler;
